import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from './imgs/logo.png';
import { useAuth } from '../AuthContext';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import { useLocation, useNavigate } from 'react-router-dom'; // ✅ added useNavigate

const Navbar = () => {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate(); // ✅ to navigate after logout

  const showLogo = location.pathname === '/builder' || location.pathname === '/view';

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/'); // ✅ redirect to homepage after logout
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      <div className="container-fluid d-flex justify-content-between align-items-center">
        {/* Brand + Logo */}
        <div className="d-flex align-items-center">
          <a className="navbar-brand mb-0" href="/">PortaForge</a>
          {showLogo && (
            <img src={logo} alt="Site Logo" height="40" className="ms-2" />
          )}
        </div>

        {/* Logout button */}
        {user && (
          <button
            onClick={handleLogout}
            className="btn btn-primary get-started-btn"
            style={{ marginTop: 0 }}
          >
            Logout
          </button>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
